const globalStyles = `
<style>
@import url('https://fonts.googleapis.com/css2?family=Quantico:wght@400;500;700;900&display=swap');
</style>
`
export default globalStyles;
